// extracted by mini-css-extract-plugin
module.exports = {"whitepaperGrid":"gf9WFJEBXRFa2SYa0SqY1","desktopView":"_39GXLXs6AIHFca9y-qulhk","mobileView":"_2BwM06I9TGYr-HseigjkRk"};